import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BaseApi } from "../base.api";
import { Button, Card, Col, Input, Row, Spin } from "antd";

export default function TranslationDetailed() {
  let { key } = useParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [translation, setTranslations] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (key) {
      loadTranslation();
    } else {
      setLoading(false);
    }
  }, [key]);
  const loadTranslation = async () => {
    try {
      const response = await new BaseApi().fetchData(
        `/common-service/v1/translations/by-key/${key}`
      );

      setTranslations(response?.data.data);
    } catch (error) {
      console.error("Error fetching translation:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Spin size="large" tip="Loading..." />
      ) : (
        <>
          <Button>
            <Link to={"/main/translations"}>Back </Link>
          </Button>
          <Button
            onClick={(e) => {
              navigate("/main/translations/update_translation", {
                state: { key },
              });
            }}
          >
            Edit
          </Button>

          <h2 style={{textAlign:"center", }}>
            Translation Detail Page
          </h2>

          <Row gutter={16}>
            {translation.map((item: any, index) => (
              <Col span={8} style={{ marginBottom: "19px" }}>
                <Card
                  style={{ height: "100%" }}
                  title={`${item.language} Language`}
                  bordered={false}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}
                  >
                    <h4 style={{ margin: 0 }}>{item.key}:</h4>
                    <p
                      style={{
                        display: "block",
                        wordWrap: "break-word",
                        maxHeight: "100%",
                      }}
                    >
                      {item.value}
                    </p>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
    </>
  );
}
